import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
} from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzMuiDeleteButton from "src/components/core-components/mui/buttons/ByzMuiDeleteButton";
import ByzMuiEditButton from "src/components/core-components/mui/buttons/ByzMuiEditButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { ByzMuiIconButton } from "src/components/core-components/mui/buttons/ByzMuiIconButton";
import CloseIcon from "@mui/icons-material/Close";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import ByzToggleIconButton from "src/components/core-components/mui/buttons/ByzToggleIconButton.tsx";
import ByzMuiSearchButton from "src/components/core-components/mui/buttons/ByzMuiSearchButton";
import ByzMuiSearchFilterButton from "src/components/core-components/mui/buttons/ByzMuiSearchFilterButton";
import ByzOkeyButton from "src/components/core-components/mui/buttons/ByzOkeyButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ByzMuiSaveButton from "src/components/core-components/mui/buttons/ByzMuiSaveButton";
import ByzPrintButtonWithText from "src/components/core-components/mui/buttons/ByzPrintButtonWithText";
import ByzMuiPastButton from "src/components/core-components/mui/buttons/ByzMuiPastButton";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import ByzMuiPrintButton from "src/components/core-components/mui/buttons/ByzMuiPrintButton";
import ByzMuiLayoutButton from "src/components/core-components/mui/buttons/ByzMuiLayoutButton";

const Buttons: React.FC = () => {
  return (
    <Card sx={{ mb: 3 }}>
      <ByzMuiTypography variant="h3" sx={{ borderBottom: "1px solid #E0E0E0" }}>
        Byz Butonlar
      </ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "100%" }}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <ByzMuiButton onClick={() => alert("Add Button Clicked")}>
                  Ekle - Sil - Değiştir
                </ByzMuiButton>
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiButton her yerde kullanılmayacak tek seferlik yerler
                  için bu nesne kullanılabilir.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiButton onClick={() => alert("Add Button Clicked")}>
                  Hastaya Ekle
                </ByzMuiButton>
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiButton her yerde kullanılmayacak tek seferlik yerler
                  için bu nesne kullanılabilir.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiAddButton onClick={() => alert("Add Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiAddButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiAddButton
                  popup={true}
                  onClick={() => alert("Add Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiAddButton (Popup açıcak ise )
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiDeleteButton
                  onClick={() => alert("Delete Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiDeleteButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiSaveButton onClick={() => alert("Add Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiSaveButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzPrintButtonWithText />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzPrintButtonWithText
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzPrintButtonWithText popup={true} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzPrintButtonWithText (Popup açıcak ise )
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiEditButton
                  onClick={() => alert("edit Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiEditButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiPastButton />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiPastButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiCheckBox onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzMuiCheckBox</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiIconButton onClick={() => alert("edit Button Clicked")}>
                  <CloseIcon sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }} />{" "}
                </ByzMuiIconButton>{" "}
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiIconButton (İçerisine icon alan tıklanabilir buton)
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiCloseButton
                  onClick={() => alert("edit Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiCloseButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzToggleIconButton
                  iconOn="/assets/icons/generals/eye-open.svg"
                  iconOff="/assets/icons/generals/eye-close.svg"
                  altText="eye"
                  //onClick={() => setIsEyeOpen(!isEyeOpen)}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzToggleIconButton (İçerisine icon alan tıklanabilir ve aktif
                  pasif gibi yapılabilen buton) 2 parametre onicon officon
                  alıyor
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiSearchButton
                  onClick={() => alert("edit Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiSearchButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiSearchFilterButton
                  onClick={() => alert("edit Button Clicked")}
                  width="50px"
                  height="50px"
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiSearchFilterButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiPrintButton type={1} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiPrintButton type 1
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
                        <TableRow>
              <TableCell>
                <ByzMuiPrintButton type={2} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiPrintButton type 2
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
                        <TableRow>
              <TableCell>
                <ByzMuiPrintButton type={3} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiPrintButton type 3
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzOkeyButton onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzOkeyButton</ByzMuiTypography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <ByzMuiIconButton>
                  <AddCircleIcon />
                </ByzMuiIconButton>
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiIconButton - Hemşire İşlemlerindeki + buton nesnesi ,
                  içerisine herhangi bir icon alabilir üstüne gelince değişen
                  rengi değişebilir.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <ByzMuiTypography variant="h3" sx={{ borderBottom: "1px solid #E0E0E0", mt: 3 }}>
        Layout Butonları
      </ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "100%" }}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <ByzMuiLayoutButton 
                  text="Süreyi Uzat" 
                  width="94px" 
                  height="20px"
                  onClick={() => alert("Layout Button Clicked")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiLayoutButton - Width, height ve text prop olarak alır.
                  Border: 1px solid #2F80ED
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default Buttons;
